// extracted by mini-css-extract-plugin
export var fullWidthButton = "_om-0";